import { NONE } from '@festina-life/api'
import { useMemo } from 'react'
import { useParams } from 'react-router'

export const useBranch = () => {
  const { branch } = useParams<{
    branch: string
  }>()

  return useMemo(
    () => (branch && branch !== NONE ? branch : undefined),
    [branch],
  )
}
